<nz-modal
  [nzMaskClosable]="true"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWrapClassName="etikett-preview-modal"
  nzWidth="90%"
  [nzStyle]="{ top: '24px', maxWidth: '1400px', paddingBottom: '0' }"
  [nzBodyStyle]="{ height: 'calc(90vh - 120px)', padding: '0', overflow: 'hidden' }"
>
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="preview-modal-body">
      <app-label-preview-host [preview]="preview" [loading]="loading"></app-label-preview-host>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
  </ng-template>
</nz-modal>
